import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_PARTNERS',
    icon: 'UserIcon',
    action: constants.action.permissionPartnerView,
    resource: constants.resource.partner,
    companyOnly: true,
    route: 'partner-list',
  },
]
